import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISearchMeta, TLoadableSearchMeta } from 'shared/types/searchMeta';

const initialState: TLoadableSearchMeta = {
  data: {} as ISearchMeta,
  isLoading: false,
};

export const searchMetaSlice = createSlice({
  name: 'searchMeta',
  initialState,
  reducers: {
    setSearchMetaIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSearchMeta: (state, action: PayloadAction<ISearchMeta>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  reducer: searchMetaReducer,
  name: searchMetaReducerName,
  actions: { setSearchMeta, setSearchMetaIsLoading },
} = searchMetaSlice;
